import Dollar from './dollar.svg'
import Rocket from './rocket.svg'
import Stars from './stars.svg'

export const icons = {
  Dollar,
  Rocket,
  Stars,
}
